// extracted by mini-css-extract-plugin
module.exports = {"toast":"toast_toast__526T_","info":"toast_info___rRRG","error":"toast_error__JscGL","success":"toast_success__WLUMy","warning":"toast_warning__LGB4F"};